export const selectedItemBg = (selected) => {
    return selected
        ? "light-dark(var(--mantine-color-gray-1), var(--mantine-color-dark-2))"
        : "transparent";
};
export const itemBorder = "0.5px solid light-dark(black, white)";
export const itemPadding = "0.375rem";
export const itemGroupGap = "0.5rem";
export const layerGroupHeaderBg = "light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4))";
export const standardThickBorder = "2px solid light-dark(black, white)";
export const horizontalInputStyle = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
};
export const horizontalWrapperProps = {
    style: horizontalInputStyle,
};
export const layerItemHeight = 30;
export const layerGroupRadius = 6;
export const panelPadding = 16;
export const panelGap = 16;
export const panelRadius = 12;
export const panelWidth = "320px";
export const panelBg = "light-dark(white, black)";
